export class OfficeVideo {
	private $container: HTMLElement;
	private readonly classActive: string = 'office-video--active';
	private readonly classInactive: string = 'office-video--inactive';
	private readonly updateInterval: number = 60 * 1000;
	private intervalId: number | null = null;

	constructor(container: HTMLElement) {
		this.$container = container;

		this.updateState();
		this.startInterval();

		(window as any).app = (window as any).app || {};
		(window as any).app.toggleOfficeVideoState = this.toggleState;
	}

	private updateState = (): void => {
		const now = new Date();
		const moscowTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Moscow' }));
		const hours = moscowTime.getHours();

		const isWorkingHours = hours >= 8 && hours < 18;
		this.toggleState(isWorkingHours);
	};

	private toggleState = (isWorkingHours: boolean): void => {
		this.$container.classList.toggle(this.classActive, isWorkingHours);
		this.$container.classList.toggle(this.classInactive, !isWorkingHours);
	};

	private startInterval = (): void => {
		this.intervalId = window.setInterval(this.updateState, this.updateInterval);
	};

	public destroy = (): void => {
		if (this.intervalId) {
			clearInterval(this.intervalId);
			this.intervalId = null;
		}
	};
}
